const checkFSKExist = fsk => {
    if(fsk === null || fsk === -1) {
        return false
    } else {
        return true
    }
}

export default checkFSKExist